var magicStyles = [".divider-text[data-v-63ac11f7]{text-align:center;margin-top:var(--magic-space--small,8px);margin-bottom:var(--magic-space--small,8px)}.label[data-v-63ac11f7]{margin-bottom:var(--magic-space--small,8px)}"];

export default magicStyles;
